const amenities = {
  'livingware': [
    'necessities',
    'detergent',
    'soap',
    'tooth_brush',
    'shampoo',
    'cleaning_tool',
    'drying_rack',
    'kitchen_ware',
    'table_ware'
  ],
  'furnitures_appliances': [
    'working_desk',
    'iron',
    'hair_dryer',
    'washer',
    'dryer',
    'refrigerator',
    'micro_wave_oven',
    'tv'
  ],
  'room_facilities': [
    'window',
    'tatami',
    'kitchen',
    'stove',
    'air_conditioner',
    'heating_equipment'
  ],
  'property_facilities': [
    'parking',
    'elevator',
    'universal_design',
    'private_pool',
    'shared_pool',
    'hot_spring',
    'sauna'
  ],
  'services': [
    'breakfast',
    'dinner',
    'with_benefits',
    'wifi',
    'internet',
    'video_on_demand',
    'cable_tv',
    'coin_shower',
    'coin_laundry',
    'vending_machine'
  ],
  'outdoor_facilities': [
    'ac_power_supply',
    'outdoor_kitchen',
    'garbage_disposal_area',
    'bbq',
    'bonfire'
  ],
  "en_translation_mapping": {
    "必需品 タオル、シーツ、石鹸、トイレットペーパー": "Necessities",
    "TV": "TV",
    "ケーブルテレビ": "Cable TV",
    "ネット動画配信サービス": "Video on demand",
    "インターネット": "Internet",
    "WIFIネット接続": "Wifi",
    "アイロン": "Iron",
    "ヘアドライヤー": "Hair Dryer",
    "エアコン": "Air conditioner",
    "駐車場込み": "Parking",
    "洗濯機": "Washer",
    "乾燥機": "Dryer",
    "洗濯物干し": "Drying rack",
    "調理器具": "Kitchenware",
    "コンロ": "Stove",
    "食器": "Tableware",
    "掃除用具": "Cleaning_tool",
    "冷蔵庫": "Refrigerator",
    "洗剤": "Detergent",
    "電子レンジ": "Microwave oven",
    "暖房設備": "Heating equipment",
    "建物にエレベーターあり": "Elevator",
    "窓あり": "Window",
    "バリアフリー": "Universal design",
    "プライベートプール": "Private pool",
    "共用プール": "Shared pool",
    "キッチン": "Kitchen",
    "机・ワークスペース": "Working desk",
    "朝食あり": "Breakfast",
    "夕食あり": "Dinner",
    "特典あり": "With benefits",
    "畳": "Tatami",
    "ソープ": "Soap",
    "歯ブラシ": "Toothbrush",
    "シャンプー": "Shampoo",
    "コインシャワー（有料）": "Coin shower",
    "コインランドリー（有料）": "Coin laundry",
    "売店、自動販売機（有料）": "Vending machine",
    "温泉": "Hot spring",
    "サウナ": "Sauna",
    "AC電源": "AC power supply",
    "炊事場": "Outdoor kitchen",
    "ゴミ捨て場": "Garbage disposal area",
    "BBQ": "BBQ",
    "たき火": "Bonfire"
  },
  "zh-TW_translation_mapping": {
    "必需品 タオル、シーツ、石鹸、トイレットペーパー": "必需品毛巾、床單、肥皂、衛生紙",
    "TV": "TV",
    "ケーブルテレビ": "有線電視",
    "ネット動画配信サービス": "互聯網視頻分發服務",
    "インターネット": "互聯網",
    "WIFIネット接続": "Wifi",
    "アイロン": "電熨斗",
    "ヘアドライヤー": "吹風機",
    "エアコン": "冷氣機",
    "駐車場込み": "包括停車位",
    "洗濯機": "洗衣機",
    "乾燥機": "烘乾機",
    "洗濯物干し": "曬衣架",
    "調理器具": "廚房用具",
    "コンロ": "火爐",
    "食器": "餐具",
    "掃除用具": "清潔工具",
    "冷蔵庫": "冰箱",
    "洗剤": "洗滌劑",
    "電子レンジ": "微波爐",
    "暖房設備": "暖氣設備",
    "建物にエレベーターあり": "樓內有電梯",
    "窓あり": "帶窗",
    "バリアフリー": "無障礙",
    "プライベートプール": "私人泳池",
    "共用プール": "公共泳池",
    "キッチン": "廚房",
    "机・ワークスペース": "辦公桌/工作區",
    "朝食あり": "含早餐",
    "夕食あり": "含晚餐",
    "特典あり": "有优惠",
    "畳": "榻榻米",
    "ソープ": "肥皂",
    "歯ブラシ": "牙刷",
    "シャンプー": "洗髮水",
    "コインシャワー（有料）": "投幣淋浴（付費）",
    "コインランドリー（有料）": "投幣洗衣機（收費）",
    "売店、自動販売機（有料）": "商店、自動售貨機（收費）",
    "温泉": "温泉",
    "サウナ": "桑拿",
    "AC電源": "AC電源",
    "炊事場": "戶外廚房",
    "ゴミ捨て場": "垃圾收集點",
    "BBQ": "BBQ",
    "たき火": "篝火"
  }
}

export default amenities
